import fxLogo from '../../../public/fpx-logo.png'
import { Link } from 'react-router-dom'

export default function FxLogo() {
  return(
    <Link to='/'>
      <img src={fxLogo} alt="Floorplan Xpress" className="absolute top-0 bottom-0 right-0 left-0 m-auto h-10" />
    </Link>
  )
}